import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setLogos, setLogo } from 'store/settings/logoSlice'
import { apiGetSiteLogos, apiUpdateSiteLogo } from 'services/SettingService'

function useSiteLogos() {

    const dispatch = useDispatch()

    const logos = useSelector((state) => state.settings.logo)

    useEffect(() => {
        if (logos.loaded) {
            return
        }
        apiGetSiteLogos().then(resp => {
            dispatch(setLogos(resp.data.logos))
        }).catch(() => {})
    }, [logos.loaded, dispatch])

    const updateLogo = async (slot, file) => {
        const formData = new FormData()
        formData.append('image', file)
        const resp = await apiUpdateSiteLogo(slot, formData)
        dispatch(setLogo({ slot, url: resp.data.url }))
        return resp.data.url
    }

    return { logos, updateLogo }
}

export default useSiteLogos
